// removed by extract-text-webpack-plugin
module.exports = {"addCategoryRow":"hAuSO6Kp5IB0oISVHVxuK","categoriesList":"_1w6M25vaUoi89N_FPeqL3O","nameField":"_1VsxHRRkuEudChYGo3JbEG","indexField":"_3uMwMyCfdoW6rdTWUxbV56"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddCategoryModal/style.css
// module id = 395
// module chunks = 0